<template>
  <div class="adviser">
    <headBox title="预约顾问" />
    <div class="inner">
      <div class="head">
        <div class="desc">
          <div class="left">
            <img src="@static/images/per.png" alt="" />
          </div>
          <div class="right">
            使用预约顾问功能，我们将为您的客户提供专业的保险咨询、非标体核保服务、家庭方案定制，帮助您高效完成交易转化。
          </div>
        </div>
      </div>
      <div class="content clearfix">
        <div class="pic">
          <img src="@static/images/marketing/phone7.png" alt="" />
        </div>
        <div class="info">
          <div class="item">
            <div class="infoTitle">凤栖云服预约顾问</div>
          </div>
          <div class="item">
            <div class="title">服务说明</div>
            <div class="body">
              <div class="content">
                客户提供手机号留咨，由专属顾问联系客户提供产品咨询和后续跟单服务<br />
                成功授权后，凤栖云服将以您的品牌名义进行服务<br />
                交易转化业绩为您的专属业绩，针对已过犹豫期业绩，我们将在平台结算日（每月15号）与您统一结算。
              </div>
              <div class="btn" @click="$router.push({path:'/setting/auth',query:{source:'1'}})">
                点击授权
              </div>
            </div>
          </div>
          <div class="item">
            <div class="title">功能入口</div>
            <div class="body">
              <div class="content">
                页面模板—工具栏配置入口 <br />
                单款产品详情页 <br />
                其他-通用预约入口，可自行配置
              </div>
              <div class="btn" @click="getLink">获取入口链接</div>
            </div>
          </div>
          <div class="item">
            <div class="title">页面个性化</div>
            <div class="body">
              <div class="content">
                您可自定义预约顾问页面头部banner，页面分享的标题、图片和描述
              </div>
              <div class="btn" @click="bannerVisibleChange">点击设置</div>
            </div>
          </div>
          <div class="item">
            <div class="title">预约顾问订单</div>
            <div class="body">
              <div class="content">
                您可进入转化跟进—预约单跟进，查看已预约客户 <br />
                点击查看详情，可查看跟进结果、跟进流程和客户状态
              </div>
              <div class="btn" @click="$router.push('/preOrder')">查看预约单</div>
            </div>
          </div>
          <div class="item last">
            <div class="titles">自定义预约顾问</div>
            <div class="body">
              <div class="content">
                您可自定义自己的预约顾问链接，自定义后凤栖云服预约顾问配置将失效，平台不再继续跟进预约订单
              </div>
              <div class="btn" @click="appointmentUrlConfig">点击设置</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="isShowLink" custom-class="yygw-dialog" :visible.sync="isShowLink" width="760px" top="5vh">
      <div class="top">
        <h1>获取预约顾问入口链接</h1>
        <p>
          您可以将预约顾问链接放置于你想推广的任意场景中，这些链接将有助于对推广渠道做统计分析
        </p>
      </div>
      <div class="tabBox">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="item.txt"
            :name="item.code"
            v-for="(item, index) in tabList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="tab-body">
        <div class="item">
          <div class="title">H5链接</div>
          <div class="content urlBox clearfix">
            <span>
              {{ h5Url }}
            </span>
            <span class="copyBtn" @click="copy(h5Url)">复制链接</span>
          </div>
        </div>
        <div class="item">
          <div class="title">H5二维码</div>
          <div class="content qrBox">
            <canvas id="codes" width="180"></canvas>
            <div class="downBtn" @click="download('codes')">下载二维码</div>
          </div>
        </div>

        <div class="item">
          <div class="title">小程序路径</div>
          <div class="content urlBox">
            <span>{{ micoUrl }} </span>
            <span class="copyBtn" @click="copy(micoUrl)">复制链接</span>
          </div>
        </div>
        <div class="item">
          <div class="title">小程序码</div>
          <div class="content qrBox">
            <img :src="getMicoCode" alt="" class="codeImg" />
            <div class="downBtn" style="margin-bottom: 0" @click="downloadCode(getMicoCode)">
              下载二维码
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title">PC链接</div>
          <div class="content urlBox">
            <span>
              {{ h5Url }}
            </span>
            <span class="copyBtn" @click="copy(h5Url)">复制链接</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      custom-class="bannerUP"
      :visible.sync="bannerVisible"
      width="700px"
      top="10vh"
    >
      <div class="title">
        <i></i>
        <span>预约顾问配置</span>
      </div>
      <div class="label">
        顶部banner
        <el-popover placement="right" trigger="hover">
          <img style="width:300px;" src="@static/images/empower6.jpg" alt />
          <span slot="reference" class="shuom">?</span>
        </el-popover>
      </div>
      <el-upload
        class="avatar-uploader"
        :action="$config.api_root + '/resmgr/upload'"
        :show-file-list="false"
        :on-success="bannerSuccess"
        :before-upload="bannerUpload"
      >
        <img
          v-if="paramsData.adviserBanner"
          :src="paramsData.adviserBanner"
          class="avatar bannerImg"
        />
        <div v-if="paramsData.adviserBanner" class="djgh">点击更换</div>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <p>
        上传图片最大不超过500kb，仅限jpg/jpeg/gif/bmp/png格式，建议Banner图片尺寸为750*360
      </p>
      <div class="label">
        分享标题
        <el-popover placement="right" trigger="hover">
          <img style="width:300px;" src="@static/images/empower7.png" alt />
          <span slot="reference" class="shuom">?</span>
        </el-popover>
      </div>
      <el-input v-model="paramsData.adviserShareTitle"></el-input>
      <div class="label">
        分享描述
        <el-popover placement="right" trigger="hover">
          <img style="width:300px;" src="@static/images/empower8.png" alt />
          <span slot="reference" class="shuom">?</span>
        </el-popover>
      </div>
      <el-input
        v-model="paramsData.adviserShareDescribe"
        type="textarea"
      ></el-input>
      <div class="label">
        分享图片
        <el-popover placement="right" trigger="hover">
          <img style="width:300px;" src="@static/images/empower9.png" alt />
          <span slot="reference" class="shuom">?</span>
        </el-popover>
      </div>
      <el-upload
        class="avatar-uploader share-upload"
        :action="$config.api_root + '/resmgr/upload'"
        :show-file-list="false"
        :on-success="shareSuccess"
        :before-upload="bannerUpload"
      >
        <img
          v-if="paramsData.adviserShareIcon"
          :src="paramsData.adviserShareIcon"
          class="avatar bannerImg"
        />
        <div v-if="paramsData.adviserShareIcon" class="djgh">点击更换</div>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <p>
        上传图片最大不超过500kb，仅限jpg/jpeg/gif/bmp/png格式，建议分享图片图片尺寸为100*100
      </p>
      <div class="bannerUpBtns">
        <el-button type="primary" @click="bannerVisible = false" plain
          >取消</el-button
        >
        <el-button type="primary" @click="bannerChangeUp">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      custom-class="bannerUP appointment-url-modal"
      :visible.sync="appointmentUrlVisible"
      width="1000px"
      top="10vh"
    >
      <div class="title">
        <i></i>
        <span>定制预约顾问</span>
      </div>
      <div class="info-text">
        系统将根据您的配置使用不同的预约顾问地址，优先级为自定义链接>通用链接>平台默认链接
      </div>
      <el-table
        ref="singleTable"
        border
        :stripe="false"
        :data="appointmentTypeList"
        style="width: 100%"
      >
        <el-table-column type="index" align="center"></el-table-column>
        <el-table-column
          property="themeName"
          label="产品类型"
          width="100px"
          align="center"
        ></el-table-column>
        <el-table-column property="productName" align="center" label="PC端">
          <template slot-scope="scope">
            <input
              type="text"
              v-model="scope.row.pcUrl"
              placeholder="请输入您的PC端链接"
            />
          </template>
        </el-table-column>
        <el-table-column property="productName" label="移动端" align="center">
          <template slot-scope="scope">
            <input
              type="text"
              v-model="scope.row.mobileUrl"
              placeholder="请输入您的移动端链接"
            />
          </template>
        </el-table-column>
        <el-table-column
          property="productName"
          label="操作"
          width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="small"
              @click="saveAppointmentUrl(scope.row)"
              >保存</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <helpTool type="adviser"></helpTool>
  </div>
</template>
<script>
var QRCode = require("qrcode");
import commom from "../../api/common";
import headBox from "@/components/head.vue";
import helpTool from "@/components/helpTool.vue";
import Clipboard from "clipboard";
export default {
  data: () => ({
    paramsData: {},
    bannerVisible: false,
    adviserShareTitle: "", // 预约顾问标题
    adviserShareDescribe: "", //预约顾问分享话术
    adviserShareIcon: "", //分享图标
    appointmentUrlVisible: false, //预约顾问链接配置弹窗
    appointmentTypeList: [{}], //预约顾问产品分类
    link: "",
    isShowLink: false,
    ishowMobile: true,
    isAdviser: true,
    isFollow: true,
    isRenewalAuthorized: true,
    paymentPlanAuthorized: true,
    isHistoryInsureders: true,//历史投被保人授权
    noFinishedOrderAuthorized: true,//未完成跟进授权
    isServer: true,
    activeName: "",
    tabList: [],
    getMicoCode: "",
    code: "",
    h5Url: ""
  }),
  components: {
    headBox,
    helpTool
  },
  created() {
    //todo
    this.code = this.$tools.getLocal("code");
    this.getShortLink();
    this.queryMechanConfig();
  },
  watch: {
    activeName() {
      this.$http({
        url: "/api/webappInsure/qrCode",
        type: "post",
        params: {
          scene: this.code + "$" + this.activeName,
          page: "pages/appointment"
        }
      }).then(data => {
        const url = this.$config.api_root + data.data;
        this.getMicoCode = url;
      });
      const url = `${this.$config.api_root}/bsite/appointment/${this.code}#/appointment?lx=${this.activeName}`;
      this.getShortLink(url).then(res => {
        this.h5Url = res;
        this.getCodeImg();
      });
    }
  },
  computed: {
    micoUrl() {
      const url = `pages/appointment?scene=${this.code}$${this.activeName}`;
      return url;
    },
    comUrl() {
      const url = `${this.$config.api_root}/bsite/appointment/${this.code}?isMobile=true#/appointment?lx=tools`;
      return url;
    }
  },
  methods: {
    // 保存预约顾问定制链接
    saveAppointmentUrl(item) {
      if (
        (item.mobileUrl && item.mobileUrl.indexOf("http") != 0) ||
        (item.pcUrl && item.pcUrl.indexOf("http") != 0)
      ) {
        this.$notice.msg("请输入http或https的链接", 2);
        return;
      }
      this.$http({
        url: "/master/subscribeServiceUrl/save",
        type: "post",
        params: item
      }).then(res => {
        this.$message.success("保存成功");
        Object.assign(item, res.data);
      });
    },
    // 获取预约顾问定制链接列表
    appointmentUrlConfig() {
      this.$http({
        url: "/master/subscribeServiceUrl/query/list",
        type: "put",
        params: {}
      }).then(res => {
        this.appointmentUrlVisible = true;
        this.appointmentTypeList = res.data;
      });
    },
    bannerVisibleChange: function() {
      this.queryMechanConfig();
      this.bannerVisible = true;
    },
    queryMechanConfig: function() {
      var that = this;
      this.$http({
        url: "/master/mechan/queryMechanConfig",
        type: "put",
        params: {}
      }).then(function(res) {
        that.paramsData = res.data;
        if (!res.data.wechatGuide) {
          that.paramsData.wechatGuide =
            "长按识别二维码或复制微信号，添加专业保险顾问为好友，将为您提供一对一专业保险服务！";
        }
        if (res.data.isAdviser != 1) {
          that.isAdviser = false;
        }
        if (res.data.ishowMobile != 1) {
          that.ishowMobile = false;
        }
        if (res.data.isFollow != 1) {
          that.isFollow = false;
        }
        if (res.data.isRenewalAuthorized != 1) {
          that.isRenewalAuthorized = false;
        }
        if (res.data.paymentPlanAuthorized != true) {
          that.paymentPlanAuthorized = false;
        }
        if (res.data.isHistoryInsureders != 1) {
          that.isHistoryInsureders = false;
        }
        if (res.data.noFinishedOrderAuthorized != true) {
          that.noFinishedOrderAuthorized = false;
        }
        that.paramsData.adviserBanner = res.data.adviserBanner;
      });
    },
    bannerChangeUp: function() {
      if (this.paramsData.adviserBanner) {
        this.updateMechanConfig();
      } else {
        this.$notice.msg("请上传图片", 2);
      }
    },
    updateMechanConfig: function() {
      var that = this;
      that.paramsData.paymentPlanAuthorized = that.paymentPlanAuthorized;
      if (that.isAdviser) {
        that.paramsData.isAdviser = 1;
      } else {
        that.paramsData.isAdviser = 0;
      }
      if (that.ishowMobile) {
        that.paramsData.ishowMobile = 1;
      } else {
        that.paramsData.ishowMobile = 0;
      }
      if (that.isFollow) {
        that.paramsData.isFollow = 1;
      } else {
        that.paramsData.isFollow = 0;
      }
      if (that.isRenewalAuthorized) {
        that.paramsData.isRenewalAuthorized = 1;
      } else {
        that.paramsData.isRenewalAuthorized = 0;
      }
      if (that.isHistoryInsureders) {
        that.paramsData.isHistoryInsureders = 1;
      } else {
        that.paramsData.isHistoryInsureders = 0;
      }
      if (that.noFinishedOrderAuthorized) {
        that.paramsData.noFinishedOrderAuthorized = 1;
      } else {
        that.paramsData.noFinishedOrderAuthorized = 0;
      }
      this.$http({
        url: "/master/mechan/updateMechanConfig",
        type: "put",
        params: that.paramsData
      }).then(function(res) {
        that.paramsData = res.data;
        if (res.data.isAdviser != 1) {
          that.isAdviser = false;
        }
        if (res.data.ishowMobile != 1) {
          that.ishowMobile = false;
        }
        if (res.data.isFollow != 1) {
          that.isFollow = false;
        }
        that.wxVisible = false;
        that.lpphoneVisible = false;
        that.bannerVisible = false;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$notice.msg("上传微信二维码图片大小不能超过 2MB!", 2);
      }
      return isLt2M;
    },
    handleAvatarSuccess(res, file) {
      this.paramsData.wechatQrcode = res.data[0].wwwurl;
    },
    bannerUpload: function(file) {
      if (file.type.indexOf("image") < 0) {
        this.$notice.msg("请上传png或jpg格式的图片", 2);
        return false;
      }
      const isLt2M2 = file.size / 1024 < 500;
      if (!isLt2M2) {
        this.$notice.msg("上传banner图片大小不能超过 500kb!", 2);
      }
      return isLt2M2;
    },
    bannerSuccess: function(res, file) {
      this.paramsData.adviserBanner = res.data[0].wwwurl;
    },
    shareSuccess: function(res, file) {
      this.paramsData.adviserShareIcon = res.data[0].wwwurl;
    },
    downloadCode: function(url) {
      console.log(url);
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();
    },
    handleClick() {
      this.getCodeImg();
    },
    getLink() {
      this.isShowLink = true;
      this.getTab();
    },
    getShortLink(url) {
      return this.$http({
        url: "/bplatTool/transformLongUrl",
        type: "put",
        params: {
          url: encodeURIComponent(url)
        }
      }).then(res => {
        this.link = res.data;
        return res.data;
      });
    },
    getTab() {
      this.$http({
        url: "/master/subscribeService/querySourceList",
        type: "put"
      }).then(res => {
        this.tabList = res.data;
        this.activeName = this.tabList[0].code;
        this.getCodeImg();
      });
    },
    copy: function(url) {
      var that = this;
      var clipboard = new Clipboard(".copyBtn", {
        text: function() {
          return url;
        }
      });
      clipboard.on("success", function(e) {
        that.linkVisible = false;
        that.$message({
          message: "复制成功",
          type: "success"
        });
        clipboard.destroy();
      });
    },
    download: function(code) {
      var url = document.getElementById(code).toDataURL("image/png");
      this.dataToBlob(url);
    },
    dataToBlob(data) {
      data = data.split(",")[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      var blob = new Blob([ia], {
        type: "image/jpeg"
      });
      var fd = new FormData();
      fd.append("img", blob, ".png");
      this.upload(fd);
    },
    upload: function(bold) {
      var that = this;
      this.$http({
        url: "/resmgr/upload",
        type: "post",
        params: bold
      }).then(function(data) {
        console.log(data.data[0].wwwurl);
        window.open(
          decodeURI(
            commom.api_root +
              "/master/custom/download?filePath=/upload" +
              data.data[0].path +
              "&fileName=" +
              data.data[0].ts +
              ".png"
          )
        );
      });
    },
    getCodeImg() {
      var canvas = document.getElementById("codes");
      QRCode.toCanvas(canvas, this.h5Url, { width: 120, height: 120,margin:0 }, function(
        error
      ) {
        if (error) console.error(error);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./adviser.scss";
</style>